module.exports = __webpack_public_path__ + "img/colors.e8a8fe62.jpg";